(function () {
  'use strict';

  const nav = document.getElementById('mgd-mobile-nav');
  if (!nav) return;

  if (window.innerWidth >= 750) return;

  let lastScrollY = window.scrollY;
  let ticking = false;
  const SCROLL_THRESHOLD = 10;

  function onScroll() {
    if (ticking) return;

    ticking = true;
    requestAnimationFrame(() => {
      const currentY = window.scrollY;
      const diff = currentY - lastScrollY;

      if (diff > SCROLL_THRESHOLD && currentY > 100) {
        nav.classList.add('mgd-mobile-nav--hidden');
      } else if (diff < -SCROLL_THRESHOLD || currentY < 50) {
        nav.classList.remove('mgd-mobile-nav--hidden');
      }

      lastScrollY = currentY;
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  function readCurrentCartCount() {
    const badge = document.getElementById('mgd-cart-badge');
    if (!badge || badge.hidden) return 0;
    return parseInt(badge.textContent, 10) || 0;
  }

  function updateCartBadge(count) {
    const badge = document.getElementById('mgd-cart-badge');
    if (!badge) return;

    const safeCount = Math.max(0, Number(count) || 0);
    const prev = readCurrentCartCount();

    if (safeCount > 0) {
      badge.textContent = safeCount > 99 ? '99+' : String(safeCount);
      badge.hidden = false;

      if (safeCount > prev && typeof gsap !== 'undefined') {
        gsap.fromTo(
          badge,
          { scale: 0.5 },
          { scale: 1, duration: 0.35, ease: 'back.out(2)' }
        );
      }
    } else {
      badge.hidden = true;
      badge.textContent = '0';
    }
  }

  function resolveCartCountFromEvent(event) {
    const resource = event.detail?.resource;
    const data = event.detail?.data || {};

    if (resource && typeof resource.item_count === 'number') {
      return resource.item_count;
    }

    if (data.source === 'product-form-component') {
      return readCurrentCartCount() + (Number(data.itemCount) || 0);
    }

    if (typeof data.itemCount === 'number') {
      return data.itemCount;
    }

    return null;
  }

  function refreshCartBadgeFromServer() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => updateCartBadge(cart.item_count))
      .catch(() => {});
  }

  document.addEventListener('cart:update', (event) => {
    const count = resolveCartCountFromEvent(event);
    if (count === null) {
      refreshCartBadgeFromServer();
      return;
    }
    updateCartBadge(count);
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshCartBadgeFromServer();
  });

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const result = originalFetch.apply(this, args);

    result.then((response) => {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      if (
        url.includes('/cart') &&
        (url.includes('add') ||
          url.includes('change') ||
          url.includes('update') ||
          url.includes('clear'))
      ) {
        refreshCartBadgeFromServer();
      }
    });

    return result;
  };

  const items = nav.querySelectorAll('.mgd-mobile-nav__item');
  items.forEach((item) => {
    item.addEventListener(
      'touchstart',
      function () {
        if (typeof gsap !== 'undefined') {
          gsap.to(this, { scale: 0.88, duration: 0.1, ease: 'power2.out' });
        }
      },
      { passive: true }
    );

    item.addEventListener(
      'touchend',
      function () {
        if (typeof gsap !== 'undefined') {
          gsap.to(this, { scale: 1, duration: 0.3, ease: 'elastic.out(1, 0.5)' });
        }
      },
      { passive: true }
    );
  });
})();
